const isNullOrEmpty = (string: string | undefined): boolean => string === undefined || string === '';

const StringUtils = {
  isNullOrEmpty,
  getNumbers: (string?: string) => (string && string.replace ? string.replace(/\D/g, '') : ''),
};

export default StringUtils;
